export enum SocialMedia {
  Facebook = "facebook",
  Instagram = "instagram",
  Linkedin = "linkedin",
  Twitter = "twitter",
  Youtube = "youtube",
}
